module.exports = __webpack_public_path__ + "static/img/penisini-richard.10b7e00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/penisini-richard.jpg
// module id = km66
// module chunks = 0